const BUILD_TIME_ISO = import.meta.env.VITE_BUILD_TIME_ISO;

/** App build timestamp formatted in US Central (CST/CDT). */
export function formatBuildDateCst(): string {
  const iso = typeof BUILD_TIME_ISO === 'string' && BUILD_TIME_ISO.trim()
    ? BUILD_TIME_ISO.trim()
    : new Date().toISOString();
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';

  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
}

export function getBuildDateLabel(): string {
  return `Built ${formatBuildDateCst()} CST`;
}

export function getLastUpdatedLabel(): string {
  return `Last updated ${formatBuildDateCst()} CST`;
}
